// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1l0z_","info":"UpdateTermsInfo_info__c1LOy"};